<template>
  <div class="medicine__item" @click="goList(goods.skuId)">
    <img
      class="medicine__item__img"
      v-if="goods.itemImg && goods.itemImg.includes('http')"
      :src="goods.itemImg"
      alt=""
    />
    <img class="medicine__item__img" v-else :src="require('@/assets/img/goods-empty.png')" />
    <div class="medicine__item__detail">
      <div class="medicine__item__detail__price">
        ¥{{ price(goods.itemMinPrice) }} - ¥{{ price(goods.itemMaxPrice) }}
      </div>
      <div class="medicine__item__detail__prod overflow">{{ goods.itemName }}</div>
      <div class="medicine__item__detail__store">{{ goods.itemFactoryNames }}</div>
    </div>
  </div>
</template>

<script>
import { priceFenToYuan } from '@/helpers/utils';

export default {
  props: {
    goods: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    goList(skuId) {
      this.$router.push({
        path: '/mallHomePage/goodsList',
        query: { skuId }
      });
    },
    price(val) {
      return priceFenToYuan(val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
.overflow {
  @include multiEllipsis(2);
}
.medicine__item {
  width: 244px;
  height: 356px;
  padding: 12px 16px;
  margin-left: 16px;
  background: #ffffff;
  &__img {
    width: 212px;
    height: 212px;
  }
  &__detail {
    margin-top: 16px;
    &__price {
      font-size: 18px;
      font-weight: 600;
      color: #fd5047;
      line-height: 1;
    }
    &__prod {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 1.5;
      margin: 8px 0;
    }
    &__store {
      font-size: 12px;
      font-weight: 400;
      color: #bcbcbc;
      line-height: 1;
    }
  }
}
</style>
